<div class="listbox-options">
  <lx-list-box [(ngModel)]="fixedDate" (ngModelChange)="triggerSelectedDateChanged()" [options]="fixedDates" data-qa="fixedDateSelection__list">
    <ng-template #customItemTemplate let-fixedDate pTemplate="item">
      {{ fixedDate?.date | lxDate : dateFormat.SHORT_MONTH_NAME }}
      <ng-container *ngIf="fixedDate?.duration">
        <span class="p-listbox-item__duration">({{ fixedDate.duration | lxLocalizeAndPluralizePeriod }})</span>
      </ng-container>
    </ng-template>
  </lx-list-box>
</div>
